import { useLocalErrorHandler } from 'hooks/useLocalErrorHandler'
import BaseBridge from 'config/bridge/BaseBridge'

import * as S from './BannerCapTorcedor.styles'
import { analyticsCapTorcedor } from './BannerCapTorcedor.tags'

export type BannerCapTorcedorProps = {
  img: string
  screen: string
}

export const BannerCapTorcedor = ({ img, screen }: BannerCapTorcedorProps) => {
  const handlerError = useLocalErrorHandler()

  const handleGoToCapTorcedor = async () => {
    analyticsCapTorcedor(screen)

    try {
      if (BaseBridge.isIOS()) {
        window.location.href = `${process.env.REACT_APP_CAP_TORCEDOR_WEBSITE_URL}`
      } else {
        await BaseBridge.openDeepLink('bancointer://capTorcedor?utm_campaign=banner-intercap')
      }
    } catch (error) {
      handlerError(
        error as Error,
        'BannerCapTorcedor.handleGoToCapTorcedor.BaseBridge.openDeepLink',
      )
    }
  }

  return (
    <S.BannerCapTorcedor onClick={handleGoToCapTorcedor}>
      <img src={img} alt="Banner Cap Torcedor" />
    </S.BannerCapTorcedor>
  )
}
